import { FC } from "react";
import { useSession } from "next-auth/client";
import { AddToCollectionModal } from "./AddToCollectionModal";

export interface Collection {
  id: string;
  name: string;
}
interface Props {
  productsIds: number[];
}

const AddToCollection: FC<Props> = ({ productsIds }) => {
  const [session] = useSession();

  if (!session || session?.user.email !== "collections@otrium.com") {
    return null;
  }

  return <AddToCollectionModal productsIds={productsIds} />;
};

export default AddToCollection;
